<script lang="ts" setup>
defineProps<{
  disabled?: boolean;
  largePreview?: boolean;
}>();
defineEmits(["changeValue", "isPdf"]);
</script>
<template>
  <EditFileChoicer
    :disabled="disabled"
    :largePreview="largePreview"
    kennung="ABLAGE"
    kennungKz="image"
    @changeValue="$emit('changeValue', $event)"
    @isPdf="$emit('isPdf', $event)"
  />
</template>
